import { AxiosResponse } from 'axios'

export const encodeUrlParameter =
  (parameter: string | number | boolean | null | undefined): string =>
    parameter === null || parameter === undefined
    ? ''
    : encodeURIComponent(parameter)

export const getAxiosData =
  <T>(response: AxiosResponse<T>) =>
    response.data

const getMsAppOrigin = (): string => {
  try {
    return new URL(document.location.ancestorOrigins?.[0] ?? document.referrer).origin
  } catch (e) {
    console.error('Failed to get parent frame URL', e)
    return 'https://online.moysklad.ru'
  }
}

export const getMsAppUrls =
  () => {
    const msAppUrlRoot = `${getMsAppOrigin()}/app`

    return ({
      root: msAppUrlRoot,
      payments: `${msAppUrlRoot}#payments`,
      orders: `${msAppUrlRoot}#customerorder`
    } as const satisfies {
      root: string
      payments: string
      orders: string
    })
  }